import { StyleSheet } from '@coursera/coursera-ui';

export const objectivesInformationCardStyles = StyleSheet.create({
  cardHeader: {
    padding: '2.25rem 3rem',
  },
  container: {
    marginLeft: -74,
    padding: '0 48px 54px',
    overflow: 'hidden',
    minWidth: 1131,

    '@media(max-width: 1440px)': {
      marginLeft: -20,
    },
  },
  column: {
    flexBasis: '30%',
    flexGrow: 1,

    ':nth-child(n+1)': {
      marginLeft: 74,

      '@media(max-width: 1440px)': {
        marginLeft: 20,
      },
    },
  },
});

export const detailedObjectivesStyles = StyleSheet.create({});
